<template>
	<el-header style="height: 60px;">
		<div class="header_box">
			<div class="left_box">
				<div class="logo_box">
					<img src="../assets/img/index/icon_3.webp" />
					<span>&ensp;Aiiso QMS</span>
				</div>
			</div>
			<div class="right_box">
				<div class="left"></div>
				<div class="right">
					<el-badge :value="overdueCount" :hidden="overdueCount == 0 ? true : false" class="item">
						<div style="cursor: pointer;" @click="goTask">
							<i class="el-icon-message-solid" style="font-size: 20px;position: relative;top: 2px;"></i> Overdue
						</div>
					</el-badge>
					<div class="btn_el">
						<el-dropdown @command="handleCommand" trigger="click">
							<div class="img_box" style="top: 0;">
								<img src="../assets/img/index/icon_1.webp" />
								<span>&ensp;{{ userAccount }}</span>
							</div>
							<template #dropdown>
								<el-dropdown-menu>
									<el-dropdown-item command="1">Change password</el-dropdown-item>
									<el-dropdown-item command="2">Log out</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
					</div>
				</div>
			</div>
		</div>
	</el-header>
</template>

<script>
import { logOut, expireNum } from '@/api/public';
export default {
	components:{},
	data() {
		return {
			isLoading: true,
			overdueCount: sessionStorage.getItem('overdueCount') || 0,
			userAccount: localStorage.getItem('userAccount') || '/',  //用户账号
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		//请求逾期数据
		expireNum().then(res => {
			if(res.code == 200) {
				sessionStorage.setItem('overdueCount', res.data);
				that.$nextTick(() => {
					if(Array.isArray(res.data)) {
						that.overdueCount = 0;
					}else {
						that.overdueCount = res.data;
					}
				});
			}
		});
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转
		goTask() {
			let that = this;
			if(that.$route.path == '/task-list') {
				window.location.reload();
			}else {
				that.$router.push({ path: '/task-list' });
			}
		},
		//修改密码
		handleCommand(command) {
			let that = this;
			if(command == 1) {
				if(that.$route.path != '/pwd') {
					that.$router.push({ path: '/pwd' });
				}
			}else if(command == 2) {
				that.$confirm('Logout?', 'Confirmation', {
					type: 'warning'
				}).then(() => {
					that.$toast.loading({ duration: 0, forbidClick: true });
					logOut({
						authtoken: localStorage.getItem('userToken')
					}).then(res => {
						if(res.code == 200) {
							localStorage.clear();
							sessionStorage.clear();
							// that.$message({ type: 'success', message: '退出成功' });
							that.$toast('Exit successful');
							setTimeout(() => {
								that.$router.replace('/login');
							}, 1500);
						}
					});
				}).catch(() => {
					// that.$message({ type: 'info', message: '您已取消退出登录' });
				});
			}
		}
	}
}
</script>

<style lang="less">
//顶部
.header_box{
	height: 100%;
	display: flex;
	align-items: center;
	padding: 0 25px;
	box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.05);
	position: relative;
	z-index: 1;
	.right_box{
		display: flex;
		align-items: center;
		padding-left: 40px;
		.right{
			width: auto;
			display: flex;
			align-items: center;
			.btn_el{
				display: flex;
				align-items: center;
				margin-left: 50px;
				cursor: pointer;
				.img_box{
					display: flex;
					position: relative;
					align-items: center;
					top: 2px;
					user-select: none;
					span{
						position: relative;
						font-size: 16px;
					}
					img{
						width: 36px;
					}
				}
				span{
					color: #333333;
					font-size: 14px;
				}
			}
		}
		.left{
			flex: 1;
			.search_box{
				display: inline-block;
				position: relative;
				.icon_box2{
					position: absolute;
					right: 16px;
					top: 10px;
				}
				.icon_box{
					position: absolute;
					left: 16px;
					top: 10px;
				}
				input{
					width: 300px;
					height: 40px;
					border: 1px solid #E5E5E5;
					border-radius: 20px;
					background-color: #F8F8F8;
					padding: 0 40px;
					color: #4886FF;
				}
			}
			.btn_el{
				display: inline-block;
				position: relative;
				top: -5px;
				margin-right: 20px;
				.van-button{
					height: 32px;
				}
			}
			
		}
	}
	.left_box{
		width: 215px;
		display: flex;
		align-items: center;
		.logo_box{
			flex: 1;
			font-size: 18px;
			font-weight: bold;
			span{
				position: relative;
				top: 8px;
				left: 4px;
				font-size: 18px;
			}
			img{
				width: 36px;
			}
		}
	}
	.right_box{
		flex: 1;
	}
}
</style>
<style scoped>
.el-header, .el-main{
	padding: 0;
}
.el-aside{
	transition: width 0.3s linear;
}
</style>
